import axios from "axios";
import store from './../index'

export default {
  state: {
    reOrderDetail: { detailId: 0, orderId: 0 },
    orderRightTab: "Новинки",
    orderLeftTab: "Товары",
    orderAnalogTab: "МНН",
    orderPriceLoading: false,
    orderDialog: {
      show: false,
      goodsQuantity: 1,
      price: {
        goodsId: 0,
        goods: {
          id: 0,
          fullName: ""
        },
        goodsPrice: 0,
        filialId: 0,
        filial: {
          name: ""
        },
        insertedDate: "",
        shelfLife: "",
        batch: "",
        priceFilialPayments: null,
        isPromotion: false,
        promotionDescription: null,
        pack: 0,
        box: 0,
        multiplicity: 0,
        isExclusive: false,
        minOrder: 0,
        isntDiscount: true,
        stored: 0,
        distributorGoodsId: "",
        isInvalid: false
      }
    },
    orders: [],
    pharmacyPoints: [],
    archiveOrders: [],
    orderNavigation: 0,
    statuses: [],
    lastOrderInfo: null,
    activePoint: null,
    getOrderFromAPI: false,
    medpredOrdersToConfirm: [],
    userSettings: null,
    sourceStorageId: null
  },
  getters: {
    GET_ORDER_FROM_API: state => {
      return state.getOrderFromAPI;
    },
    GET_PHARMACY_POINTS: state => {
      return state.pharmacyPoints;
    },
    RE_ORDER_DETAIL: state => {
      return state.reOrderDetail;
    },
    ORDER_RIGHT_TAB: state => {
      return state.orderRightTab;
    },
    ACTIVE_POINT: state => {
      return state.activePoint;
    },
    ORDER_LEFT_TAB: state => {
      return state.orderLeftTab;
    },
    ORDER_ANALOG_TAB: state => {
      return state.orderAnalogTab;
    },
    ORDER_PRICE_LOADING: state => {
      return state.orderPriceLoading;
    },
    ORDERS: state => {
      return state.orders.filter(x => x.orderDetails.length !== 0);
    },
    ARCHIVE_ORDERS: state => {
      return state.archiveOrders.filter(
        x => x.orderDetails.length != 0
      );
    },
    ORDER_DIALOG: state => {
      return state.orderDialog
    },
    ORDER_NAVIGATION: state => {
      return state.orderNavigation;
    },
    STATUSES: state => {
      return state.statuses;
    },
    LAST_ORDER_INFO: state => {
      return state.lastOrderInfo;
    },
    MEDPRED_ORDERS_TO_CONFIRM: state => {
      return state.medpredOrdersToConfirm;
    },
    ORDER_SOURCE_STORAGE_ID: state => {
      return state.sourceStorageId;
    },
  },
  mutations: {
    SET_USER_SETTINGS(state, userSettings) {
        state.userSettings = userSettings;
    },
    SET_ORDER_SOURCE_STORAGE_ID: (state, payload) => {
      state.sourceStorageId = payload;
    },
    SET_ORDER_FROM_API: (state, payload) => {
      state.getOrderFromAPI = payload;
    },
    SET_PHARMACY_POINTS: (state, payload) => {
      state.pharmacyPoints = payload;
    },
    SET_RE_ORDER_DETAIL: (state, payload) => {
      state.reOrderDetail = payload;
    },
    SET_ORDER_RIGHT_TAB: (state, payload) => {
      state.orderRightTab = payload;
    },
    SET_ACTIVE_POINT: (state, payload) => {
      state.activePoint = payload;
    },
    SET_ORDER_LEFT_TAB: (state, payload) => {
      state.orderLeftTab = payload;
    },
    SET_ORDER_ANALOG_TAB: (state, payload) => {
      state.orderAnalogTab = payload;
    },
    SET_LOADING_ORDER_PRICE: (state, payload) => {
      state.orderPriceLoading = payload;
    },
    SET_ORDERS: (state, payload) => {
      state.orders = payload;
    },
    SET_STATUSES: (state, payload) => {
      state.statuses = payload;
    },
    SET_ARCHIVE_ORDERS: (state, payload) => {
      state.archiveOrders = payload;
    },
    SET_NEW_ORDER: (state, payload) => {
      state.orders.push(payload);
    },
    SET_NEW_ORDERS: (state, payload) => {
      // state.orders = state.orders.concat(payload);
      state.orders.push(...payload);
    },
    SET_NEW_DETAIL: (state, payload) => {
      const order = state.orders.find(x => x.id === payload.orderId);
      if (!order) return;

      order.orderDetails.push(payload);

      if (state.userSettings?.isOrderDetailsAlphabetSorting) {
        order.orderDetails.sort((a, b) =>
            a.goods.fullName.localeCompare(b.goods.fullName, "ru")
        );
    }
    },
    SET_UPDATE_DETAIL: (state, payload) => {
      const order = state.orders.find(o => o.id === payload.order.id);
      if (!order) return;

      const detail = order.orderDetails.find(d => d.id === payload.id);
      if (detail) {
        detail.quantity = payload.quantity;
      }
    },
    SET_UPDATE_DETAILS: (state, payload) => {
      state.orders.find(
        x => x.id == payload.id
      ).orderDetails = payload.orderDetails
    },
    SET_UPDATE_ORDER_DETAILS: (state, {updatedOrder, orderId}) => {
      let orderIndex = state.orders.findIndex(x => x.id == orderId);

      state.orders = [
        ...state.orders.slice(0, orderIndex),
        updatedOrder,
        ...state.orders.slice(orderIndex + 1)
      ];
    },
    SET_DELETE_ORDER: (state, payload) => {
      state.orders = state.orders.filter(
        x => x.id != payload
      );
    },
    SET_DELETE_ORDER_BY_USER(state, userId) {
      state.orders = state.orders.filter(order => order.PHC_user?.userId !== userId);
    },
    SET_CHANGED_ORDER: (state, payload) => {
      state.orders.find(
        x => x.id == payload.id
      ).orderDetails = payload.orderDetails
    },
    SET_CHECK_IN_PRICE_DETAILS: (state, payload) => {
      state.orders.find(
        x => x.id == payload.id
      ).orderDetails = payload.orderDetails
    },
    SET_SPLIT_DETAILS: (state, payload) => {
      var orderId = payload[0].orderId;
      let detailsId = payload.map(x => x.id);
      // state.orders.find(x => x.id == orderId).orderDetails = orderDetails;
      state.orders.find(x => x.id == orderId).orderDetails = state.orders.find(x => x.id == orderId).orderDetails.filter(x => !detailsId.includes(x.id));
    },
    SET_DELETE_DETAILS: (state, payload) => {
        const order = state.orders.find(x => x.id === payload.orderId);
        if (!order) return;
        order.orderDetails = order.orderDetails.filter(
          x => !payload.deletedIds.includes(x.id)
        )
    },
    SET_DELETE_MOVE_DETAILS: (state, payload) => {
      var orderId = payload[0].orderId;

      var detailsIds = payload.map(x => x.id);

      state.orders.find(x => x.id == orderId).orderDetails = state.orders.find(x => x.id == orderId).orderDetails.filter(x => !detailsIds.includes(x.id))
    },
    SET_MOVE_DETAILS_TO_ORDER: (state, payload) => {

      store.commit('SET_DELETE_MOVE_DETAILS', payload.details);

      payload.details.forEach(function (detail) {
        detail.orderId = payload.toOrderId;
      })

      state.orders.filter(
        x => x.id == payload.toOrderId
      )[0].orderDetails.push(...payload.details)
    },
    SET_ORDER_DIALOG: (state, payload) => {
      state.orderDialog = payload;
    },
    SET_ORDER_NAVIGATION: (state, payload) => {
      state.orderNavigation = payload;
    },
    SET_LAST_ORDER_INFO: (state, payload) => {
      state.lastOrderInfo = payload;
    },
    SET_DELETE_DETAILS_FROM_STORAGE: (state, payload) => {
      var orderId = payload[0].orderId;
      let stateOrderDetails = state.orders.find(x => x.id == orderId).orderDetails;
      if (stateOrderDetails.length == payload.length) {
        state.orders = state.orders.filter(
          x => x.id != orderId
        );
      }
      else {
        let tempArr = stateOrderDetails.filter(
          (item) => !payload.map(x => x.id).includes(item.id)
        );

        state.orders.find(x => x.id == orderId).orderDetails = tempArr;
      }
    },
    SET_MEDPRED_ORDERS_TO_CONFIRM: (state, payload) => {
      state.medpredOrdersToConfirm = payload;
    },
  },
  actions: {
    async CHECK_MIN_SUM_ORDER({ commit }, orderId) {
        try {
            await axios.get(
                `/Order/CheckMinSumOrderByIdAsync?orderId=${orderId}`
            );
            return true;
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Произошла ошибка при проверке заказа";
        
            const Snackbar = {
                text: errorMessage,
                timeout: 7500,
                color: "error",
                linkText: "",
                show: true,
            };
            commit("SET_SNACKBAR", Snackbar);
            return false;
        }
    },
    GET_USER_SETTINGS: async ({ commit }) => {
        const { data } = await axios.get("/Order/GetUserSettings");
        commit("SET_USER_SETTINGS", data.userSettings);
    },
    ADJUST_ORDER_DETAILS_ALPHABET_SORTING: async ({ dispatch }, value) => {
        await axios.post(
            "/Order/AdjustOrderDetailsAlphabetSorting",
            {
                isOrderDetailsAlphabetSorting: value
            }
        );
        await dispatch("GET_USER_SETTINGS");
    },
    CREATE_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/Create`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              if (data.status == 7) {
                let Warning = {
                  text: 'Не соблюдены условия кратности товара!',
                  timeout: 5000,
                  color: 'warning',
                  show: true
                }
                store.commit('SET_SNACKBAR', Warning);
                resolve(true);
                return;
              }
              store.commit('SET_NEW_ORDER', data.items);
              payload.OrderDetails.filter(x => x.StorageId).forEach(x => {
                store.commit('SET_REMOVE_STORAGE_GOODS', {
                  goodsIds: [x.GoodsId],
                  storageId: x.StorageId
                });
              });
              if (data.status != 6) {
                let Success = {
                  text: 'Ваш заказ успешно создан с номером ' + data.items.id,
                  timeout: 5000,
                  color: 'success',
                  link: '#order' + data.items.id,
                  linkText: 'Перейти',
                  show: true
                }
                store.commit('SET_SNACKBAR', Success);
                resolve(true);
              }
              else {
                let Warning = {
                  text: 'Добавьте нагружаемый товар в заказ: ' + data.items.id,
                  timeout: 5000,
                  color: 'warning',
                  link: '#order' + data.id,
                  linkText: 'Перейти',
                  show: true
                }
                store.commit('SET_SNACKBAR', Warning);
                resolve(true);
              }
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
      REORDER: async ({ commit }, payload) => {
      try {
          const { data, status } = await axios.post('/Order/Reorder', payload);

          if (status === 200) {
              if (data.status == 7) {
                  commit('SET_SNACKBAR', {
                      text: 'Не соблюдены условия кратности товара!',
                      timeout: 5000,
                      color: 'warning',
                      show: true
                  });

                  return true;
              }

              commit('SET_NEW_ORDER', data.items.order);

              if (data.status != 6) {
                  commit('SET_SNACKBAR', {
                      text: 'Ваш заказ успешно создан с номером ' + data.items.order.id,
                      timeout: 5000,
                      color: 'success',
                      link: '#order' + data.items.order.id,
                      linkText: 'Перейти',
                      show: true
                  });
              } else {
                  commit('SET_SNACKBAR', {
                      text: 'Добавьте нагружаемый товар в заказ: ' + data.items.order.id,
                      timeout: 5000,
                      color: 'warning',
                      link: '#order' + data.items.order.id,
                      linkText: 'Перейти',
                      show: true
                  });
              }
              return await data.items.editedPreviousOrderDetailCount;
          }

      } catch (error) {
          const message = error.response?.data?.message ?? "Неизвестная ошибка";
          window.console.log(`ОШИБКА:${message}`)
          commit('SET_SNACKBAR', {
                      text: `${message}`,
                      timeout: 5000,
                      color: 'warning',
                      show: true
                  }); 
          throw error;
      }
  },
    ORDERS: (commit, payload) => {
      store.commit('SET_ORDERS', []);
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetAllByContextAsyncAsNoTracking`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              store.commit('SET_ORDERS', data);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });
    },
    ORDERS_BY_USER: (commit, payload) => {
      store.commit('SET_ORDERS', []);
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetAllByUserIdAsyncAsNoTracking?userId=` + payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_ORDERS', data);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })
      });

    },
    ALL_ORDERS: (commit, payload) => {
      store.commit('SET_ORDERS', []);
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/GetAllAsync`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              // store.commit('SET_ORDERS', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    STATUSES: (commit, payload) => {
      store.commit('SET_STATUSES', []);
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetStatuses`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    ARCHIVE_ORDERS: (commit, payload) => {
      store.commit('SET_ORDERS', []);
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/GetArchivesByContextAsync`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              // store.commit('SET_ORDERS', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    ARCHIVE_ORDERS_FILIAL: (commit, payload) => {
      store.commit('SET_ORDERS', []);
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/GetArchivesByFilialAsync`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              // store.commit('SET_ORDERS', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    CREATE_DETAIL: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/CreateDetail`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {

              if (data.status == 6) {
                let Warning = {
                  text: 'Не соблюдены условия кратности товара!',
                  timeout: 5000,
                  color: 'warning',
                  show: true
                }
                store.commit('SET_SNACKBAR', Warning);
                resolve(true);
                return;
              }

              if (data.type == 0) {
                if (data.status == 0 || data.status == 2) {
                  store.commit('SET_NEW_DETAIL', data.items);
                  if (payload.StorageId) {
                    store.commit('SET_REMOVE_STORAGE_GOODS', {
                      goodsIds: [payload.GoodsId],
                      storageId: payload.StorageId
                    });
                  }
                  let Success = {
                    text: 'Ваш товар успешно добавлен к заказу с номером ' + data.items.orderId,
                    timeout: 5000,
                    color: 'success',
                    link: '#detail' + data.items.id,
                    linkText: 'Перейти'
                  }
                  store.commit('SET_SNACKBAR', Success);
                  resolve(true);
                }
                else {
                  let Warning = {
                    text: 'Товар не может быть добавлен к заказу(Акция) ',
                    timeout: 5000,
                    color: 'warning',
                    link: '',
                    linkText: '',
                    show: true
                  }
                  store.commit('SET_SNACKBAR', Warning);
                  resolve(true);
                }
              }
              else if (data.type == 1) {
                if (data.status == 0 || data.status == 2) {
                  store.commit('SET_NEW_DETAIL', data.items);
                  if (payload.StorageId) {
                    store.commit('SET_REMOVE_STORAGE_GOODS', {
                      goodsIds: [payload.GoodsId],
                      storageId: payload.StorageId
                    });
                  }
                  let Success = {
                    text: 'Ваш товар успешно добавлен к заказу с номером ' + data.items.orderId,
                    timeout: 5000,
                    color: 'success',
                    link: '#detail' + data.items.id,
                    linkText: 'Перейти'
                  }
                  store.commit('SET_SNACKBAR', Success);
                  resolve(true);
                }
                else {
                  let Warning = {
                    text: 'Товар не может быть добавлен к заказу(Нагрузка) ',
                    timeout: 5000,
                    color: 'warning',
                    link: '',
                    linkText: '',
                    show: true
                  }
                  store.commit('SET_SNACKBAR', Warning);
                  resolve(true);
                }
              }
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    DELETE_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/Order/DeleteById?id=` + payload)
          .then(({
            status
          }) => {
            if (status === 200) {
              store.commit('SET_DELETE_ORDER', payload);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });
    },
    DELETE_ORDER_BY_USER: ({ commit }, userId) => {
      return axios
        .delete(`/Order/DeleteAllByUserId?userId=` + userId)
        .then(({ status }) => {
          if (status === 200) {
            commit('SET_DELETE_ORDER_BY_USER', userId);
            return true; // важно вернуть, чтобы then сработал
          }
          throw new Error("Ошибка удаления");
        });
    },
    DELETE_DETAILS: (commit, payload) => {
      let detailsId = payload.map(x => x.id);
      return new Promise((resolve, reject) => {
        axios
          .delete(`/Order/DeleteDetailsById`, {
            data: detailsId
          })
          .then(({
            data, status
          }) => {
            if (status === 200) {
              window.console.log('data', data)
              if (!data.orderDeleted)
                store.commit('SET_DELETE_DETAILS', data);
              else
                store.commit('SET_DELETE_ORDER', data.orderId);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    SPLIT_DETAILS: (commit, payload) => {
      let detailsId = payload.map(x => x.id);
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/SplitDetailsById`,
            detailsId
          )
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_SPLIT_DETAILS', payload);
              store.commit('SET_NEW_ORDER', data);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    UPDATE_DETAIL: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .put(`/Order/UpdateDetail`,
            payload
          )
          .then(({
            status, data
          }) => {
            if (status === 200) {
              if (data.status == 7) {
                let Warning = {
                  text: 'Не соблюдены условия кратности товара!',
                  timeout: 5000,
                  color: 'warning',
                  show: true
                }
                store.commit('SET_SNACKBAR', Warning);
                resolve(data);
                return;
              }
              window.console.log('detail', data.items);
              store.commit('SET_UPDATE_DETAIL', data.items);
              if (payload.StorageId) {
                store.commit('SET_REMOVE_STORAGE_GOODS', {
                  goodsIds: [payload.GoodsId],
                  storageId: payload.StorageId
                });
              }
              if (data.status != 6) {
                let Success = {
                  text: 'Ваш заказ успешно изменен с номером ' + data.items.order.id,
                  timeout: 5000,
                  color: 'success',
                  link: '#order' + data.items.order.id,
                  linkText: 'Перейти',
                  show: true
                }
                store.commit('SET_SNACKBAR', Success);
                resolve(true);
              }
              else {
                let Warning = {
                  text: 'Добавьте нагружаемый товар в заказ: ' + data.items.order.id,
                  timeout: 5000,
                  color: 'warning',
                  link: '#order' + data.items.order.id,
                  linkText: 'Перейти',
                  show: true
                }
                store.commit('SET_SNACKBAR', Warning);
                resolve(true);
              }
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    MOVE_DETAILS_TO_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .put(`/Order/MoveDetails?toOrderId=` + payload.toOrderId,
            payload.details.map(x => x.id),
          )
          .then(({
            status
          }) => {
            if (status === 200) {
              store.commit('SET_MOVE_DETAILS_TO_ORDER', payload);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    INITIALIZE_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/InitializeAsync?filialId=` + payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              window.console.log(data)
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    SEND_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/SendAsync`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    OPTIMIZED_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/OptimizeOrder/Optimized`, payload)
          .then(({
            status
          }) => {

            if (status === 200) {
              let Success = {
                text: 'Отимизированный заказ выполнен. Выделенные позиции не найдены в прайсах.',
                timeout: 5000,
                color: 'success',
              }
              store.commit('SET_SNACKBAR', Success);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    OPTIMIZED_ORDER_DISTRS: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/OptimizeOrder/OptimizedWithDistributors`, payload)
          .then(({
            status
          }) => {

            if (status === 200) {
              let Success = {
                text: 'Отимизированный заказ выполнен. Выделенные позиции не найдены в прайсах.',
                timeout: 5000,
                color: 'success',
              }
              store.commit('SET_SNACKBAR', Success);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    OPTIMIZED_ORDER_EXCEL: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/OptimizeOrder/OptimizedOrderExcel`, payload, {
            responseType: 'blob'
          })
          .then(response => {
            if (response.status === 200) {
              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              });

              const url = window.URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = url;

              const contentDisposition = response.headers['content-disposition'];
              let fileName = "optimized_order.xlsx";

              if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                fileName = contentDisposition
                  .split('filename=')[1]
                  .split(';')[0]
                  .replace(/"/g, '')
                  .trim();
              }

              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();

              link.remove();
              window.URL.revokeObjectURL(url);

              store.commit('SET_SNACKBAR', {
                text: 'Оптимизированный заказ успешно выгружен в Excel.',
                timeout: 5000,
                color: 'success',
              });

              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    ORDERS_GROUPED_BY: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/GetAllGroupedByAsync`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              // store.commit('SET_ORDERS', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetById?id=` + payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_UPDATE_DETAILS', data);
              resolve(data);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    ORDER_IN_CHAT: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetById?id=` + payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              resolve(data);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    CLONE_ORDER: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/Clone?existingId=` + payload)
          .then(({
            status
          }) => {

            if (status === 200) {
              let Success = {
                text: 'Заказ успешно создан',
                timeout: 5000,
                color: 'success',
                show: true
              }
              store.commit('SET_SNACKBAR', Success);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    UPDATE_DISCOUNTS_BY_USER_BIN_AND_ORDERID: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .put(`/Order/UpdateDiscountsByBINAndOrderId?accessUserBIN=` + payload.accessUserBIN + `&orderId=` + payload.orderId,
            payload
          )
          .then(({
            status
          }) => {
            if (status === 200) {
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    GET_LAST_ORDER_INFO: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetLastOrderInfo?goodsId=` + payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              store.commit('SET_LAST_ORDER_INFO', data)
              resolve(data);
            }
            else {
              store.commit('SET_LAST_ORDER_INFO', null)
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    GET_RE_ORDER_DETAIL: (commit, payload) => {
      store.commit("SET_RE_ORDER_DETAIL", payload);
    },
    SET_DELETE_DETAILS_FROM_STORAGE: (commit, payload) => {
      store.commit("SET_DELETE_DETAILS_FROM_STORAGE", payload);
    },
    GET_PHARMACY_POINTS: (commit, payload) => {
      store.commit('SET_PHARMACY_POINTS', []);
      return new Promise((resolve, reject) => {
        axios
          .get(`/User/GetPharmacyPoints`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200) {
              store.commit('SET_PHARMACY_POINTS', data);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
    GET_MEDPRED_ORDERS_TO_CONFIRM: (commit, payload) => {
      store.commit('SET_MEDPRED_ORDERS_TO_CONFIRM', []);
      return new Promise((resolve, reject) => {
        axios
          .get(`/Order/GetMedpredOrdersToConfirm`, payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_MEDPRED_ORDERS_TO_CONFIRM', data);
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });
    },
    UPDATE_MEDPRED_ORDERS_STATUS: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Order/UpdateMedpredOrdersStatusAsync`,
            payload
          )
          .then(({
            status
          }) => {
            if (status === 200) {
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    },
  async DOWNLOAD_ORDERS_IN_EXCEL(commit, orderId = null) {
      const params = {};

      if (orderId !== null) {
        params.orderId = orderId;
      }

      return await axios
        .get("/Order/GetOrderDetailsInExcel", {
          params,
          responseType: "blob"
        })
        .then((response) => {
          const blob = new Blob([response.data]);

          let filename = "PHorders.xlsx";

          const disposition = response.headers["content-disposition"];

          if (disposition) {
            const matchOld = disposition.match(/filename="?(.+?)"?$/);
            const matchNew = disposition.match(/filename\*=UTF-8''([^;]+)/);
            
            if (matchNew?.[1]) {
              filename = decodeURIComponent(matchNew[1]);
            } else if (matchOld?.[1]) {
              filename = matchOld[1];
            }
          }

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(link.href);
        });
    },
    
    
    DOWNLOAD_ARCHIVE_ORDER_XML(commit, id) {
      return axios
        .get(`/Order/GetOrderXml?id=${id}`, { responseType: 'blob' })
        .then(({ data }) => {
          let filename = `order-PH${id}.xml`;
          const fileURL = URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
    },
    async CHECK_IN_PRICE_DETAILS(commit, order) {
      try {
        const { data, status } = await axios.post(`/Order/CheckOrderDetailsInPrice`, order);
       
        if (status === 200) {
          return data;
        } else {
          throw new Error(`Unexpected response status: ${status}`);
        }
      } catch (error) {
        throw error;
      }
    }
  }
};